export const mergeTrendData = (currentPeriodData, prevPeriodData, mergeKey, mergeKeyAccessor = null) => {
  const defaultMergeKeyAccessor = (d) => d[mergeKey];
  mergeKeyAccessor = mergeKeyAccessor ?? defaultMergeKeyAccessor;
  const previousMap =
    prevPeriodData?.reduce((acc, row) => {
      const key = mergeKeyAccessor(row);
      acc[key] = row;
      return acc;
    }, {}) ?? {};

  return (
    currentPeriodData?.map((row) => {
      const key = mergeKeyAccessor(row);
      row["key"] = key;
      const prevRow = previousMap?.[key];

      const compareFn = (key, row, prevRow) => {
        return {
          [`${key}_delta`]: row[key] - prevRow[key],
          [`${key}_percent`]: prevRow[key] !== 0 ? (row[key] - prevRow[key]) / prevRow[key] : null,
          [`${key}_prev`]: prevRow[key],
        };
      };

      if (prevRow) {
        const metricKeys = [];

        for (const key in row) {
          if (typeof row[key] === "number") metricKeys.push(key);
        }

        return metricKeys.reduce((acc, metric) => {
          return {
            ...acc,
            ...compareFn(metric, row, prevRow),
          };
        }, row ?? {});
      }
      return row;
    }) ?? []
  );
};
